import script from "./SubjectMarker.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectMarker.vue?vue&type=script&setup=true&lang=js"

import "./SubjectMarker.vue?vue&type=style&index=0&id=63c0c20a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c0c20a"]])

export default __exports__